// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.current-conditions {
  padding: var(--spacing-lg);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.conditions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-lg);
}

.card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}

.location-badge {
  font-size: 0.75rem;
  padding: var(--spacing-xs) var(--spacing-sm);
  background: var(--accent-blue);
  background: linear-gradient(135deg, var(--accent-blue), var(--accent-cyan));
  border-radius: var(--radius-sm);
  color: white;
}

.conditions-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.temperature-display {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.main-weather-icon {
  width: 100px;
  height: 100px;
}

.temperature-info {
  display: flex;
  flex-direction: column;
}

.current-temp {
  font-size: 3.5rem;
  font-weight: 300;
  color: var(--text-primary);
  line-height: 1;
}

.feels-like {
  font-size: 0.9rem;
  color: var(--text-muted);
  margin-top: var(--spacing-xs);
}

.condition-description {
  margin-top: var(--spacing-md);
  font-size: 1.1rem;
  color: var(--text-secondary);
  text-transform: capitalize;
}

.conditions-details {
  margin-top: var(--spacing-lg);
  padding-top: var(--spacing-lg);
  border-top: 1px solid var(--border-color);
}

.detail-row {
  display: flex;
  justify-content: space-around;
}

.detail {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.detail-icon {
  font-size: 1.25rem;
}

.detail-content {
  display: flex;
  flex-direction: column;
}

.detail-label {
  font-size: 0.75rem;
  color: var(--text-muted);
}

.detail-value {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-primary);
}`, "",{"version":3,"sources":["webpack://./src/components/CurrentConditions/CurrentConditions.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,8BAA8B;EAC9B,2EAA2E;EAC3E,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":[".current-conditions {\n  padding: var(--spacing-lg);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.conditions-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-lg);\n}\n\n.card-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.location-badge {\n  font-size: 0.75rem;\n  padding: var(--spacing-xs) var(--spacing-sm);\n  background: var(--accent-blue);\n  background: linear-gradient(135deg, var(--accent-blue), var(--accent-cyan));\n  border-radius: var(--radius-sm);\n  color: white;\n}\n\n.conditions-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.temperature-display {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n.main-weather-icon {\n  width: 100px;\n  height: 100px;\n}\n\n.temperature-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.current-temp {\n  font-size: 3.5rem;\n  font-weight: 300;\n  color: var(--text-primary);\n  line-height: 1;\n}\n\n.feels-like {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  margin-top: var(--spacing-xs);\n}\n\n.condition-description {\n  margin-top: var(--spacing-md);\n  font-size: 1.1rem;\n  color: var(--text-secondary);\n  text-transform: capitalize;\n}\n\n.conditions-details {\n  margin-top: var(--spacing-lg);\n  padding-top: var(--spacing-lg);\n  border-top: 1px solid var(--border-color);\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-around;\n}\n\n.detail {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.detail-icon {\n  font-size: 1.25rem;\n}\n\n.detail-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.detail-label {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.detail-value {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
